import React from 'react';
import _ from 'lodash';
import { useParams } from 'react-router-dom';
import { useQuery } from 'react-fetching-library';
import { Typography, Collapse, Stack, Button, Box } from '@mui/material';
import { getLatestFormAction, getClientDataAction } from '../../../services/request';
import { FormPanel } from '../../../components/form/FormPanel';
import LoginOrRegister from './LoginOrRegister';
import { useResponsive } from '../../../services/hooks';
import { Header } from '../../../components/landing/Header';

const WyjazdyRodzinneFormPage = ({ formIdentifier }) => {
  const params = useParams();
  const { loading, payload, error } = useQuery(getLatestFormAction(formIdentifier));
  const { loading: clientLoading, payload: clientPayload, error: clientError } = useQuery(getClientDataAction());
  const [form, setForm] = React.useState(null);
  const [clientData, setClientData] = React.useState({});
  const isDesktop = useResponsive('up', 'lg');

  React.useEffect(() => {
    if (!error && !loading) {
      setForm(payload);
    }

    if (!clientError && !clientLoading) {
      if (!_.isNil(clientPayload.name)) {
        const lastIndex = clientPayload.name.lastIndexOf(' ');
        const name = clientPayload.name.substr(0, lastIndex);
        const surname = clientPayload.name.substr(lastIndex + 1);
        const client = { ...clientPayload, name, surname };
        setClientData(client);
      } else {
        setClientData(clientPayload);
      }

    }

  }, [loading, clientLoading]);

  if (error) {
    return <Typography>Nie udało się załadować formularza</Typography>;
  }

  return (
    <div>
      <Header isDesktop={isDesktop} redirectUrl="https://sun-sport.pl/lato/" />
      <Stack spacing={2} direction={isDesktop ? 'column' : 'column-reverse'}>
        {form != null
          ? <div>
            <div style={isDesktop ? { paddingLeft: '5vw', paddingRight: '5vw' } : {}}>
              <FormPanel form={form} clientData={clientData} />
            </div>
          </div>
          : null}
      </Stack>
    </div>
  );
};

export default WyjazdyRodzinneFormPage;
